(function (angular) {
  "use strict";

  angular.module("app").service("locations", locations);

  locations.$inject = ["$q"];

  function locations($q) {
    const AutocompleteService =
      new window.google.maps.places.AutocompleteService();
    const PlacesService = new window.google.maps.places.PlacesService(
      document.getElementById("hidden-map-results"),
    );

    /**
     * Returns autocomplete place suggestions for a provided query string
     * @param searchId is a unique ID that is send back with every response
     * @return {promise}
     */
    function findLocations(queryString, searchId) {
      var deferred,
        results = [];

      deferred = $q.defer();

      if (!queryString.length) {
        deferred.resolve(false);
        return false;
      }

      // Get place results from google
      AutocompleteService.getQueryPredictions(
        { input: queryString },
        function (predictions) {
          // Build a better response object
          angular.forEach(predictions, function (prediction) {
            // Some predictions don't have a place_id (for example "hotels" as it's just a generic suggestion)
            if (prediction.place_id) {
              results.push({
                searchId: searchId,
                name: prediction.terms[0].value,
                country: prediction.terms[prediction.terms.length - 1].value,
                location:
                  prediction.terms.length > 2
                    ? prediction.terms[prediction.terms.length - 2].value
                    : "",
                placeId: prediction.place_id,
              });
            }
          });

          deferred.resolve(results);
        },
      );

      return deferred.promise;
    }

    /**
     * Retrieves info about a specific place from google
     * @param  {string} placeId - google place id
     * @return {promise}
     */
    function getLocationDetails(placeId) {
      var deferred = $q.defer(),
        response = {};

      PlacesService.getDetails({ placeId: placeId }, function (place, status) {
        if (status === "OK") {
          // Build a better response object
          var addressParts = flattenAddressComponents(place.address_components);

          angular.extend(response, {
            name: place.name,
            address: {
              line_1: place.name,
              line_2:
                (addressParts.street_number_long || "") +
                " " +
                (addressParts.route_long || ""),
              town_city: addressParts.postal_town_long || "",
              county: addressParts.administrative_area_level_2_short || "",
              postcode: addressParts.postal_code_long || "",
              country: addressParts.country_short || "",
            },
            formatted_address: place.formatted_address,
            coords: {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            },
            tel: place.international_phone_number,
            icon: place.icon,
          });

          deferred.resolve(response);
        } else {
          deferred.reject();
        }
      });

      /**
       * Makes a flat object of address components indexed by "types", so we can predictably pluck the parts we want
       * @param  {array} addressComponents - Array of objects provided in the response
       * @return {object}                  - Object of address parts
       */
      function flattenAddressComponents(
        addressComponents,
      ): Record<string, string> {
        var flattened = {};

        angular.forEach(addressComponents, function (component) {
          angular.forEach(component.types, function (type) {
            flattened[type + "_long"] = component.long_name;
            flattened[type + "_short"] = component.short_name;
          });
        });

        return flattened;
      }

      return deferred.promise;
    }

    /**
     * Creates a new google map from coords, and adds to dom using elSelector
     * @param  {object} coords     - containing lat, lng
     * @param  {string} elSelector - DOM selector where map will be added
     * @return {void}
     */
    function makeMap(coords, elSelector) {
      if (!coords || !coords.lat || !coords.lng) {
        console.warn("lat, lng must be provided to makeMap()");
        return false;
      }

      coords.lat = parseFloat(coords.lat);
      coords.lng = parseFloat(coords.lng);

      var map, marker;

      map = new window.google.maps.Map($(elSelector)[0], {
        center: coords,
        zoom: 12,
        mapTypeId: "roadmap",
      });

      marker = new window.google.maps.Marker({
        position: coords,
        map: map,
      });
    }

    return {
      find: findLocations,
      getDetails: getLocationDetails,
      makeMap: makeMap,
    };
  }
})(angular);
